import Modal from "@/components/Modal/Modal";
import { PinMiniIcon } from "@/components/SVGComponents/MemberIcons";
import { combineClasses } from "@/lib/utils";
import styles from "./EventDetailsModal.module.scss";

export interface EventDetailsData {
  id: number | string;
  title: string;
  description: string;
  date: string;
  time: string;
  guestCount: number;
  location: string | null;
  mapUrl: string | null;
}

interface EventDetailsModalProps {
  event: EventDetailsData | null;
  isOpen: boolean;
  onClose: () => void;
}

const getVenueUrl = (mapUrl: string | null, location: string | null) => {
  if (mapUrl?.trim()) {
    return mapUrl.trim();
  }

  if (location?.trim()) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location.trim())}`;
  }

  return null;
};

const EventDetailsModal = ({
  event,
  isOpen,
  onClose,
}: EventDetailsModalProps) => {
  if (!event) {
    return null;
  }

  const venueUrl = getVenueUrl(event.mapUrl, event.location);
  const hasVenue = Boolean(event.location?.trim());

  const handleOpenVenue = () => {
    if (!venueUrl) {
      return;
    }

    window.open(venueUrl, "_blank", "noopener,noreferrer");
  };

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <Modal
      bodyClassName={styles.modalBody}
      className={combineClasses(styles.modal, "event-details-modal")}
      closeModal={handleCloseModal}
      heading="Event Details"
      modalOpen={isOpen}
    >
      <div className={styles.panel}>
        <div className={styles.eventSummary}>
          <h3 className={styles.eventName}>{event.title}</h3>
          {event.description ? (
            <p className={styles.eventDescription}>{event.description}</p>
          ) : null}
        </div>

        <div className={styles.detailsGrid}>
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Date</span>
            <strong className={styles.detailValue}>{event.date}</strong>
          </div>
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>From</span>
            <strong className={styles.detailValue}>{event.time}</strong>
          </div>
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Guests</span>
            <strong className={styles.detailValue}>{event.guestCount}</strong>
          </div>
        </div>

        {hasVenue ? (
          <div className={styles.directionsRow}>
            <div className={styles.directionsCopy}>
              <PinMiniIcon className={styles.directionsIcon} />
              <span className={styles.directionsText}>Directions to venue</span>
            </div>
            <button
              className={styles.openButton}
              onClick={handleOpenVenue}
              type="button"
            >
              Open
            </button>
          </div>
        ) : null}

        <button className={styles.okayButton} onClick={onClose} type="button">
          Okay
        </button>
      </div>
    </Modal>
  );
};

export default EventDetailsModal;
